import { createContext, useContext } from 'react'
import { User } from '@/types'

interface UserInfoContextType {
  userInfo: Partial<User> | null
  setUserInfo: (userInfo: Partial<User> | null) => void
}

export const UserInfoContext = createContext<UserInfoContextType | undefined>(
  undefined
)

export const useUserInfo = () => {
  const context = useContext(UserInfoContext)
  if (!context) {
    throw new Error('useUserInfo must be used within a UserProvider')
  }
  return context
}
